import axios from 'axios'
import appConfig from '@/app.config.js'

export default class Request {

    constructor (config) {

        var defaultConfig = Object.assign({
            baseURL: appConfig.apiBaseUrl,
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json'
            }
        }, config)

        this.request = axios.create(defaultConfig)
    }

    post (url, formData, options = {}) {

        return this.request.post(url, formData, options)
    }

    get (url, data) {

        return this.request.get(url, data)
    }

    put (url, formData) {

        return this.request.put(url, formData)
    }

    patch (url, formData) {

        return this.request.patch(url, formData)
    }

    delete (url, formData) {

        return this.request.delete(url, formData)
    }
}
